import { Injectable } from '@angular/core';
import { SigningServiceHttp } from '../signing-service';

@Injectable({
    providedIn: 'root'
})

export class EsignAndSmsPinService {

    constructor(
        private http: SigningServiceHttp
    ) {}


    /**
     * Sends an SMS PIN to the specified recipient.
     *
     * @param role_id - The ID of the role to which the SMS PIN will be sent.
     * @returns An `Observable` representing the HTTP POST request to send the PIN.
     */
    sendSmsPin(role_id: number, phone_no: string) {
        return this.http.post(`sign-document/${role_id}/send-code`, {phone_no: phone_no});
    }

    /**
     * Verifies the provided PIN for a specific role.
     *
     * @param role_id - The ID of the role for which the PIN verification is being performed.
     * @param pin - The PIN to be verified.
     * @returns An Observable containing the server's response to the PIN verification request.
     */
    verifyPin(role_id: number, form) {
        return this.http.post(`sign-document/${role_id}/pin-verify`, form);
    }

}